export const eternityMilestones = {
  autobuyerIPMult: {
    eternities: 1,
    reward: "Разблокируйте АвтоПокупщик множителя Очков Бесконечности",
    pelleUseless: true
  },
  keepAutobuyers: {
    eternities: 2,
    reward: "В начале Вечности все Нормальные Челленджи пройдены, все нормальные АвтоПокупщики открыты, и " +
      "бесконечность преодолена"
  },
  autobuyerReplicantiGalaxy: {
    eternities: 3,
    reward: "Разблокируйте АвтоПокупщик Галактик Репликантов"
  },
  keepInfinityUpgrades: {
    eternities: 4,
    reward: "Вы начинаете Вечность со всеми Улучшениями Бесконечности",
    givenByPelle: () => PelleUpgrade.keepInfinityUpgrades.isBought,
    pelleUseless: true
  },
  bigCrunchModes: {
    eternities: 5,
    reward: "Разблокируйте больше опций для АвтоПокупщика Большого Хруста"
  },
  autoEP: {
    eternities: 6,
    reward: () => {
      const EPmin = getOfflineEPGain(TimeSpan.fromMinutes(1).totalMilliseconds);
      const em200 = getEternitiedMilestoneReward(TimeSpan.fromHours(1).totalMilliseconds,
        EternityMilestone.autoEternities.isReached).gt(0);
      const em1000 = getInfinitiedMilestoneReward(TimeSpan.fromHours(1).totalMilliseconds,
        EternityMilestone.autoInfinities.isReached).gt(0);
      if (!player.options.offlineProgress) return `Этот рубеж дал бы вам офлайн генерацию ОВ, но офлайн прогресс
        на данный момент отключен`;
      const effectText = (em200 || em1000) ? "Неактивен" : `Сейчас ${format(EPmin, 2, 2)} ОВ/мин`;
      return `Пока офлайн, получайте ${formatPercents(0.25)} ваших лучших Очков Вечности в минуту с предыдущих Вечностей
        (${effectText})`;
    },
    activeCondition: () => (player.options.offlineProgress
      ? `Активен до тех пор, пока никакой из остальных рубежей офлайн генерации
        (${formatInt(200)} или ${formatInt(1000)}) не активен`
      : ""),
  },
  autoIC: {
    eternities: 7,
    reward: `Вы проходите Челленджи Бесконечности как только разблокируете их,
      и сохраняете АвтоПокупщик Жертвования Измерений`,
    pelleUseless: true
  },
  keepBreakUpgrades: {
    eternities: 8,
    reward: "Вы начинаете Вечность со всеми Улучшениями Преодоления Бесконечности",
    givenByPelle: () => PelleUpgrade.keepBreakInfinityUpgrades.isBought,
    pelleUseless: true
  },
  autobuyMaxGalaxies: {
    eternities: 9,
    reward: "Разблокируйте режим покупки максимума для АвтоПокупщика Галактик Антиматерии"
  },
  unlockReplicanti: {
    eternities: 10,
    reward: "Репликанты разблокированы в начале Вечности",
    givenByPelle: () => PelleUpgrade.replicantiStayUnlocked.isBought,
    pelleUseless: true
  },
  autobuyerID1: {
    eternities: 11,
    reward: "Разблокируйте АвтоПокупщик 1ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID2: {
    eternities: 12,
    reward: "Разблокируйте АвтоПокупщик 2ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID3: {
    eternities: 13,
    reward: "Разблокируйте АвтоПокупщик 3его Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID4: {
    eternities: 14,
    reward: "Разблокируйте АвтоПокупщик 4ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID5: {
    eternities: 15,
    reward: "Разблокируйте АвтоПокупщик 5ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID6: {
    eternities: 16,
    reward: "Разблокируйте АвтоПокупщик 6ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID7: {
    eternities: 17,
    reward: "Разблокируйте АвтоПокупщик 7ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerID8: {
    eternities: 18,
    reward: "Разблокируйте АвтоПокупщик 8ого Измерения Бесконечности",
    givenByPelle: () => PelleUpgrade.IDAutobuyers.isBought,
    pelleUseless: true
  },
  autoUnlockID: {
    eternities: 25,
    reward: "Вы автоматически разблокируете Измерения Бесконечности, как только достигаете их"
  },
  unlockAllND: {
    eternities: 30,
    reward: "Все Измерения Антиматерии доступны для покупки с самого начала"
  },
  replicantiNoReset: {
    eternities: 40,
    reward: `Галактики Репликантов больше не сбрасывают Антиматерию, Измерения Антиматерии,
      Скорость Тика, Жертвование Измерений и Бусты Измерений`,
    pelleUseless: true
  },
  autobuyerReplicantiChance: {
    eternities: 50,
    reward: "Разблокируйте АвтоПокупщик Улучшения Шанса Репликантов",
    givenByPelle: () => PelleUpgrade.replicantiAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerReplicantiInterval: {
    eternities: 60,
    reward: "Разблокируйте АвтоПокупщик Улучшения Интервала Репликантов",
    givenByPelle: () => PelleUpgrade.replicantiAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerReplicantiMaxGalaxies: {
    eternities: 80,
    reward: "Разблокируйте АвтоПокупщик Улучшения Максимума Галактик Репликантов",
    givenByPelle: () => PelleUpgrade.replicantiAutobuyers.isBought,
    pelleUseless: true
  },
  autobuyerEternity: {
    eternities: 100,
    reward: "Разблокируйте АвтоПокупщик для Вечностей"
  },
  autoEternities: {
    eternities: 200,
    reward: () => {
      if (!player.options.offlineProgress) return `Этот рубеж генерировал бы вечности офлайн, но офлайн
        прогресс на данный момент отключен`;
      const eternities = getEternitiedMilestoneReward(TimeSpan.fromHours(1).totalMilliseconds,
        player.eternities.gte(200));
      // As far as I can tell, using templates here as Codefactor wants would lead to nested templates,
      // which seems messy to say the least.
      const realTime = PlayerProgress.seenAlteredSpeed() ? " (реального времени)" : "";
      // eslint-disable-next-line prefer-template
      return `Пока офлайн, получайте Вечности со скоростью ${formatPercents(0.5)} от вашей самой быстрой${realTime} ` +
        "Вечности " + (eternities.gt(0) ? `(Сейчас ${format(eternities, 2, 2)}/час)` : "(Неактивно)");
    },
    activeCondition: () => (player.options.offlineProgress
      ? `Необходимо быть снаружи всех Челленджей и Растяжения, а АвтоПокупщик Вечностей должен быть установлен на
        Вечность на нуле ОВ. Эффект этого рубежа ограничен до ${formatInt(33)}мс.`
      : ""),
    pelleUseless: true
  },
  autoInfinities: {
    eternities: 1000,
    reward: () => {
      if (!player.options.offlineProgress) return `Этот рубеж генерировал бы бесконечности офлайн, но офлайн
        прогресс на данный момент отключен`;
      const infinities = getInfinitiedMilestoneReward(TimeSpan.fromHours(1).totalMilliseconds,
        player.eternities.gte(1000));
      // eslint-disable-next-line prefer-template
      return `Пока офлайн, получайте Бесконечности, равные ${formatPercents(0.5)}
        от ваших лучших Бесконечностей/час в этой Вечности ` +
        (infinities.gt(0) ? `(Сейчас ${format(infinities, 2, 2)}/час)` : "(Неактивно)");
    },
    activeCondition: () => (player.options.offlineProgress
      ? `Необходимо быть снаружи Нормальных/Бесконечных Челленджей и снаружи ВЧ4 и ВЧ12,
        АвтоПокупщик Большого Хруста должен быть включен и установлен на режим времени с ${formatInt(5)} секундами или
        меньше, а АвтоПокупщик Вечности должен быть отключен.`
      : ""),
    pelleUseless: true
  }
};
